import { Button, Input, message, Modal, Space } from "antd"
import { useState } from "react"
import { useSearchParams } from "react-router-dom"
import { useActions } from "../../../hooks/useActions"
import projectDataApi from "../api/projectDataApi"

const { TextArea } = Input

const AddAsin: React.FC = () => {
  const [open, setOpen] = useState(false)
  const [asin, setAsin] = useState("")

  const [searchParams] = useSearchParams()
  const projectId = searchParams.get("projectId")
  const { getProjectData, getProject } = useActions()

  function addAsins() {
    if (!projectId) {
      return
    }

    const asins = asin
      .split(",")
      .map((asin) => asin.trim())
      .filter((asin) => asin.length > 0)

    projectDataApi
      .addAsins(projectId, asins)
      .then(() => {
        setOpen(false)
        setAsin("")
        getProjectData(projectId)
        getProject(projectId)
      })
      .catch((error) => {
        message.error(error)
      })
  }

  return (
    <>
      <Button onClick={() => setOpen(true)}>Add Asin</Button>

      <Modal
        title="Add Asin"
        open={open}
        onCancel={() => setOpen(false)}
        footer={
          <Space>
            <Button onClick={() => setOpen(false)}>Cancel</Button>
            <Button type="primary" onClick={addAsins}>
              Add
            </Button>
          </Space>
        }
      >
        <TextArea
          placeholder="Asin (use comma to separate)"
          value={asin}
          onChange={(e) => setAsin(e.target.value)}
        />
      </Modal>
    </>
  )
}

export default AddAsin
